var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgUndo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m8.342 7.743.185-.632-.185-.633L9.608 5.29a.7.7 0 0 0 .225-.527.783.783 0 0 0-.225-.527.751.751 0 0 0-.54-.236.714.714 0 0 0-.53.22L6.272 6.478A.867.867 0 0 0 6 7.111c0 .24.09.452.271.632l2.248 2.258c.155.155.334.23.535.225a.764.764 0 0 0 .534-.24.768.768 0 0 0 .22-.532.705.705 0 0 0-.22-.522L8.342 7.743Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 6.25h9.75v11.5H7v-1.5h9.25v-8.5H8v-1.5Z",
  fill: "currentColor"
})));

export default SvgUndo;